module.exports = __webpack_public_path__ + "img/logo_casa_goias.5511b269.svg";